<div class="modal-backdrop" (click)="dialogRef.close()"></div>
<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">Conceder Acesso a Novo Usuário por Email</h3>
    </div>

    <div class="modal-body">
      <mat-form-field appearance="outline" floatLabel="always" class="mb-md">
        <mat-label>Email</mat-label>
        <input matInput type="email" #email />
      </mat-form-field>
    </div>

    <div class="modal-footer">
      <button class="btn btn-ghost" (click)="dialogRef.close()">Cancelar</button>
      <button class="btn btn-primary" (click)="dialogRef.close(email.value)">Conceder Acesso</button>
    </div>
  </div>
</div>
